import { sendToApi } from 'api/client'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { useMutation } from 'react-query'
import { UseMutationOptions } from 'react-query/types/react/types'

type Data = void

export type Options = Omit<UseMutationOptions<Data, Error, number>, 'mutationKey' | 'mutationFn'>

export const deleteMediaFile = async (workspaceId: number, id: number) => {
  const res = await sendToApi(`/w/${workspaceId}/media_files/${id}`, {
    method: 'DELETE',
  })

  if (res.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error(res.data)
  }

  return res.data
}

export const useDeleteMediaFile = (options?: Options) => {
  const workspaceId = useCurrentWorkspaceId()
  return useMutation<Data, Error, number>((id) => deleteMediaFile(workspaceId, id), options)
}
